/* tslint:disable */
/* eslint-disable */
export enum Sorting {
  Asc = 'ASC',
  Desc = 'DESC'
}
